<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  class="confirm-dialog"
  contentStyleClass="mb-2 p-1 overflow-visible"
  [header]="'contactUsForm.documentInfoPopup.title' | translate">
  <ng-template pTemplate="content">
    <div class="flex justify-between items-center border rounded-md p-3 pr-0 mb-4">
      <div class="flex items-center truncate">
        <i class="pi pi-file mr-3 text-xl"></i>
        <p class="font-bold truncate">
          {{ fileName }}
        </p>
      </div>
      <button
        pButton
        icon="pi pi-times"
        class="p-button-text text-black shrink-0"
        (click)="onClose()"></button>
    </div>
    <label
      for="documentType"
      class="block text-dark text-sm mb-2"
      >{{ "contactUsForm.documentInfoPopup.documentType" | translate }}
    </label>
    <p-dropdown
      [(ngModel)]="selectedType"
      [options]="documentTypes"
      optionLabel="shortLabel"
      optionValue="code"
      [placeholder]="'contactUsForm.documentInfoPopup.dropdownPlaceholder' | translate"
      appendTo="body"
      styleClass="mb-4 w-full"></p-dropdown>
  </ng-template>

  <ng-template pTemplate="footer">
    <button
      pButton
      [label]="'contactUsForm.documentInfoPopup.validate' | translate"
      [disabled]="!selectedType"
      (click)="onSave()"
      class="bg-primary text-white w-full h-12 mb-2"></button>
    <button
      pButton
      [label]="'contactUsForm.documentInfoPopup.cancel' | translate"
      (click)="onClose()"
      class="bg-white border border-primary text-primary w-full font-wigrum-light h-12"></button>
  </ng-template>
</p-dialog>
